import { trigger, state, style, transition, animate } from '@angular/animations';

export const tableExpand = [
  [
    trigger('detailExpand', [
      state('collapsed, void',
        style({ height: '0px', minHeight: '0', padding: '0', borderBottom: 'none' })
      ),
      state('expanded', style({ height: '*', padding: '24px 0' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
];
